/**
 * Build rate update payloads based on job diffs.
 * @param {Object} params
 * @param {Object} params.job - Current job data
 * @param {Object} params.data - Incoming update data
 * @returns {Array<{ id: string, charge: string, value: number }>}
 */
export const getRateUpdatePayloads = ({ job = {}, data = {} }) => {
  const payloads = [];
  const toFiniteRate = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : null;
  };

  const nextBaseRate = toFiniteRate(data.baseRate);
  const nextFuelRate = toFiniteRate(data.fuelRate);
  const currentBaseRate = toFiniteRate(job?.baseRate ?? job?.base) ?? 0;
  const currentFuelRate = toFiniteRate(job?.fuelRate ?? job?.fuel) ?? 0;

  const baseRateChanged =
    nextBaseRate !== null && nextBaseRate !== currentBaseRate;
  const fuelRateChanged =
    nextFuelRate !== null && nextFuelRate !== currentFuelRate;

  if (baseRateChanged) {
    payloads.push({
      id: "baseRate",
      charge: "baseCharge",
      value: nextBaseRate,
    });
  }

  if (fuelRateChanged) {
    payloads.push({
      id: "fuelRate",
      charge: "fuelSurcharge",
      value: nextFuelRate,
    });
  }

  return payloads;
};

/**
 * Remove rate-related fields from a job update payload.
 * @param {Object} data
 * @returns {Object}
 */
export const sanitizeJobUpdateData = (data = {}) => {
  const sanitized = { ...(data || {}) };
  delete sanitized.baseRate;
  delete sanitized.fuelRate;
  delete sanitized.flatRate;
  delete sanitized.useGlobalRates;
  delete sanitized.useFlatRate;
  return sanitized;
};
